<template>
  <div>
    <SetupAnalyticContainer
      v-if="!hasPromotionBeenSetup"
      containerTitle="Event Promotion "
      containerSubtitle="No. of people who have shared your event"
      bodyTitle="You have not set up promotion for your event "
      description="Once it has been set up, your event promotion count will appear here."
      btnText="Set up promotion for your event"
      @click="currentEvent.currentTab = 3"
    />
    <v-card outlined v-else>
      <v-card-title>Event Promotion </v-card-title>
      <v-card-subtitle
        >No. of people who have shared your event on
        {{ currentEvent.socialMediaPlatform }}.</v-card-subtitle
      >
      <!-- clicked on the option to promote -->
      <v-divider></v-divider>
      <v-card-text class="pa-0 grey lighten-5">
        <v-tabs v-model="tab">
          <v-tab class="text-capitalize">Promotional Post</v-tab>
          <v-tab class="text-capitalize">Social Media Promotion</v-tab>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <v-row>
                <v-col cols="12" md="12" class="pl-8">
                  <div>
                    Reactions and comments on Pappyon in-app promotional post.
                  </div>
                </v-col>
                <v-col cols="6" class="pl-8">
                  <div>Reactions</div>
                </v-col>
                <v-col cols="6">
                  <div>{{ noOfPostReactions }}</div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="6" class="pl-8">
                  <div>Comments</div>
                </v-col>
                <v-col cols="6">
                  <div>{{ noOfPostComments }}</div>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item>
              <v-row>
                <v-col cols="6" class="pl-8"> Pre-event </v-col>
                <v-col cols="3">{{ totalPreEventShareCount }}</v-col>
                <v-col cols="3"
                  ><v-btn
                    text
                    small
                    color="primary"
                    @click="
                      viewClickCount(
                        'PRE-EVENT',
                        preEventPromotionAnalyticData,
                        'Pre-event social sharing'
                      )
                    "
                    >View</v-btn
                  ></v-col
                >
                <v-col cols="12" class="pt-0">
                  <v-divider></v-divider>
                </v-col>
                <v-col cols="6" class="pl-8">Post-event</v-col>
                <v-col cols="3">{{ totalPostEventShareCount }}</v-col>
                <v-col cols="3"
                  ><v-btn
                    text
                    small
                    color="primary"
                    @click="
                      viewClickCount(
                        'POST-EVENT',
                        postEventPromotionAnalyticData,
                        'Post-event social sharing'
                      )
                    "
                    >View</v-btn
                  ></v-col
                >
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
    </v-card>
    <ViewClickDetailsDialog
      v-if="showClickDetailsDialog"
      :show="showClickDetailsDialog"
      :dialogTitle="dialogTitle"
      :totalClickOrShareCount="totalShareCount"
      :analyticData="selectedPromotionAnalyticData"
      @close="showClickDetailsDialog = false"
      type="PROMOTION_ANALYTICS"
    />
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import SetupAnalyticContainer from "./SetupAnalyticContainer";
import ViewClickDetailsDialog from "./ViewClickDetailsDialog";
import {getPostDoc} from "@/shared/firebase_utils";

export default {
  components: {
    SetupAnalyticContainer,
    ViewClickDetailsDialog,
  },
  computed: {
    ...mapGetters(["currentEvent"]),
    hasPromotionBeenSetup() {
      if (this.currentEvent.socialMediaPlatform) return true;
      else return false;
    },
    preEventPromotionAnalyticData() {
      if (this.currentEvent.socialMediaPlatform == "Facebook") {
        return this.currentEvent.facebookPreEventPromotionAnalyticData;
      } else if (this.currentEvent.socialMediaPlatform == "Instagram") {
        return this.currentEvent.instagramPreEventPromotionAnalyticData;
      } else {
        return this.currentEvent.linkedinPreEventPromotionAnalyticData;
      }
    },
    postEventPromotionAnalyticData() {
      if (this.currentEvent.socialMediaPlatform == "Facebook") {
        return this.currentEvent.facebookPostEventPromotionAnalyticData;
      } else if (this.currentEvent.socialMediaPlatform == "Instagram") {
        return this.currentEvent.instagramPostEventPromotionAnalyticData;
      } else {
        return this.currentEvent.linkedinPostEventPromotionAnalyticData;
      }
    },
    totalPreEventShareCount() {
      let count = 0;
      this.preEventPromotionAnalyticData.forEach((item) => {
        count += item.shareCount;
      });
      return count;
    },
    totalPostEventShareCount() {
      let count = 0;
      this.postEventPromotionAnalyticData.forEach((item) => {
        count += item.shareCount;
      });
      return count;
    },
    noOfPostReactions() {
      let noOfPostReactions = 0;

      if (this.promotionalPost.noOfLikes)
        noOfPostReactions += this.promotionalPost.noOfLikes;
      if (this.promotionalPost.noOfLoves)
        noOfPostReactions += this.promotionalPost.noOfLoves;
      if (this.promotionalPost.noOfPraises)
        noOfPostReactions += this.promotionalPost.noOfPraises;

      return noOfPostReactions;
    },
    noOfPostComments() {
      return this.promotionalPost.noOfComments || "-";
    },
  },
  async created() {
    console.log("this.currentEvent.postId: ", this.currentEvent.postId);

    let promotionalPostDocRef = await getPostDoc(this.currentEvent.postId);

    if (promotionalPostDocRef.exists)
      this.promotionalPost = promotionalPostDocRef.data();
  },
  data() {
    return {
      dialogTitle: "",
      showClickDetailsDialog: false,
      selectedPromotionAnalyticData: null,
      totalShareCount: 0,
      tab: 0,
      promotionalPost: {},
    };
  },
  methods: {
    viewClickCount(type, analyticData, dialogTitle) {
      this.dialogTitle = dialogTitle;
      this.totalShareCount =
        type == "PRE-EVENT"
          ? this.totalPreEventShareCount
          : this.totalPostEventShareCount;
      this.selectedPromotionAnalyticData = analyticData;
      this.showClickDetailsDialog = true;
    },
  },
};
</script>

<style>
</style>